import(/* webpackMode: "eager" */ "/app/apps/public/app/error.tsx");
